import * as React from 'react'
import { Button } from '@material-ui/core'
import OrganizationInfoHoverIcon from 'images/white-label/organization-info.png'
import TypographyHoverIcon from 'images/white-label/typography.png'
import StatePagesHoverIcon from 'images/white-label/state.png'
import ContactApplicationHoverIcon from 'images/white-label/contact.png'
import OrganizationInfoIcon from 'images/white-label/organization-info-t.png'
import TypographyIcon from 'images/white-label/typography-t.png'
import StatePagesIcon from 'images/white-label/state-t.png'
import ContactApplicationIcon from 'images/white-label/contact-t.png'
import OrganizationLayoutLink from '../components/OrganizationLayoutLink'
import { useStyles } from './styles'
import PublishButton from '../components/PublishButton'
import RevertButton from '../components/RevertButton'

const EditOrganizationLayout: React.FC<{
  organizationId: string
  reloadOrganization: () => void
  isWhiteLabel: boolean
  subDomain: string
  handlePublish?: () => void
  isFormEdited: boolean
  isWhiteLabelPage: boolean
  customUrl?: string
}> = ({
  children,
  organizationId,
  reloadOrganization,
  isWhiteLabel,
  subDomain,
  handlePublish,
  isFormEdited,
  isWhiteLabelPage,
  customUrl,
}) => {
  const classes = useStyles()

  const showPopup = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isFormEdited) {
      const result = confirm('Are you sure you want to leave this page? Unsaved changes will be lost.')
      if (!result) {
        event.preventDefault()
      }
    }
  }

  return (
    <div className={classes.editOrganizationWrapper}>
      <div className={classes.menu}>
        <div className={classes.menuHeader}>
          <h3 className='is-size-4 has-text-weight-normal'>EXEC Portal Settings</h3>
          <p className='is-size-7 has-text-weight-normal'>Customize your platform experience</p>
        </div>
        <div className={classes.menuHeader}>
          {isWhiteLabelPage ? (
            <div className={classes.menuHeaderActions}>
              <PublishButton id={organizationId} />
              <RevertButton id={organizationId} className={classes.w100} reloadOrganization={reloadOrganization} />
            </div>
          ) : (
            <Button
              color='primary'
              variant='contained'
              fullWidth
              onClick={() => {
                handlePublish?.()
              }}
              className='mb-2'
            >
              Apply changes
            </Button>
          )}

          <Button
            variant='outlined'
            fullWidth
            component='a'
            href={`https://${subDomain}${isWhiteLabelPage ? '-test' : ''}.${window.location.host}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {isWhiteLabelPage ? 'Preview' : 'View site'}
          </Button>
          {customUrl && !isWhiteLabelPage && (
            <Button
              variant='outlined'
              fullWidth
              component='a'
              href={`https://${customUrl}`}
              target='_blank'
              rel='noopener noreferrer'
              className='mt-2'
            >
              View custom domain
            </Button>
          )}
        </div>
        <div className={classes.menuLinks}>
          <ul>
            <li>
              <OrganizationLayoutLink
                text='EXEC Portal info'
                subText='Basic organization details'
                to={`/panel/organizations/${organizationId}/edit/details`}
                onClick={showPopup}
                imageUrl={OrganizationInfoIcon}
                hoverImageUrl={OrganizationInfoHoverIcon}
              />
            </li>
            {isWhiteLabel && (
              <>
                <li>
                  <OrganizationLayoutLink
                    text='Typography & Visual Style'
                    subText='Fonts and styling options'
                    to={`/panel/organizations/${organizationId}/edit/typography`}
                    onClick={showPopup}
                    imageUrl={TypographyIcon}
                    hoverImageUrl={TypographyHoverIcon}
                  />
                </li>
                <li>
                  <OrganizationLayoutLink
                    text='State Pages & Legal'
                    subText='Legal documents and pages'
                    to={`/panel/organizations/${organizationId}/edit/legal`}
                    onClick={showPopup}
                    imageUrl={StatePagesIcon}
                    hoverImageUrl={StatePagesHoverIcon}
                  />
                </li>
                <li>
                  <OrganizationLayoutLink
                    text='Contact & Application'
                    subText='Contact forms and settings'
                    to={`/panel/organizations/${organizationId}/edit/contact`}
                    onClick={showPopup}
                    imageUrl={ContactApplicationIcon}
                    hoverImageUrl={ContactApplicationHoverIcon}
                  />
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      <div className='pl-6 pr-6 pt-6'>{children}</div>
    </div>
  )
}

export default EditOrganizationLayout
